// // ============ ADD TO CART (auto-applied discount + Zipify cart pop-out) ============
// // Click: prime the LDW30 discount cookie -> AJAX add the variant to cart ->
// // open the Zipify slide cart. If anything fails (e.g. previewing this file
// // off-store), falls back to the classic /discount/ redirect which always works.
// const DISCOUNT_PATH = '/discount/LDW30';
// let discountPrimed = false;
// async function primeDiscount(){
//   if(discountPrimed) return;
//   try{ await fetch(DISCOUNT_PATH + '?redirect=/cart', {credentials:'same-origin'}); discountPrimed = true; }catch(e){}
// }
// function openZipifyCart(){
//   // [ZIPIFY-CART-HOOK] Zipify's slide cart normally opens on cart add. If the
//   // installed version needs an explicit call, wire its JS API here at port.
//   try{
//     document.dispatchEvent(new CustomEvent('cart:open'));
//     document.dispatchEvent(new CustomEvent('ocu:cart:open'));
//     if(window.OCUSlideCart && typeof window.OCUSlideCart.open === 'function') window.OCUSlideCart.open();
//   }catch(e){}
// }
// async function addToCart(btn){
//   const id = Number(btn.dataset.variant), handle = btn.dataset.handle;
//   const label = btn.querySelector('span'); const orig = label.textContent;
//   btn.disabled = true; label.textContent = 'Adding...';
//   try{
//     await primeDiscount();
//     const r = await fetch('/cart/add.js', {method:'POST', credentials:'same-origin',
//       headers:{'Content-Type':'application/json'},
//       body: JSON.stringify({items:[{id:id, quantity:1}]})});
//     if(!r.ok) throw new Error('add failed');
//     label.textContent = 'Added ✓';
//     openZipifyCart();
//     setTimeout(()=>{ label.textContent = orig; btn.disabled = false; }, 1800);
//   }catch(e){
//     btn.disabled = false; label.textContent = orig;
//     location.href = DISCOUNT_PATH + '?redirect=/products/' + handle;
//   }
// }
// document.querySelectorAll('.cta.atc').forEach(b=>b.addEventListener('click', ()=>addToCart(b)));

// copy code
function copyCode(btn){
  const code = document.getElementById('codeTxt').textContent.trim();
  function done(){ btn.textContent = 'Copied ✓'; setTimeout(()=>btn.textContent='Copy', 2200); }
  if(navigator.clipboard && navigator.clipboard.writeText){
    navigator.clipboard.writeText(code).then(done).catch(()=>{fallback();});
  } else { fallback(); }
  function fallback(){
    const ta=document.createElement('textarea'); ta.value=code; document.body.appendChild(ta);
    ta.select(); try{document.execCommand('copy'); done();}catch(e){} document.body.removeChild(ta);
  }
}

// countdown — [SALE-END-ISO]: set the real end datetime at port
const SALE_END = new Date('2026-09-10T04:59:59Z'); // 11:59pm CT, Wed Sept 9
let saleOver = false;
function endSale(){
  if(saleOver) return; saleOver = true;
  document.body.classList.add('sale-over');
  const ann = document.querySelector('.announce');
  if(ann) ann.innerHTML = 'The Labor Day sale has ended. Thanks for a great weekend, patriots. 🇺🇸';
  document.querySelectorAll('.card .cta span:first-child').forEach(el=>{ el.textContent = 'Shop This Pack'; });
  const sb = document.querySelector('.stickybar a'); if(sb) sb.textContent = 'Shop 4-Packs →';
  const sr = document.querySelector('.stickyrev'); if(sr) sr.textContent = '★★★★★ 35,000+ PATRIOTS SERVED';
  // scrub every remaining sale reference so a dead offer is never advertised
  document.querySelector('.h1').innerHTML = 'Handcrafted Soap<br><span class="accent">For People Who Work.</span>';
  document.querySelector('.hero-sub').textContent = 'America was built by people who work. Cold-pressed bar soap and grass-fed tallow, made in the Midwest and ready to ship.';
  const subs = document.querySelectorAll('.sec-sub');
  if(subs[0]) subs[0].textContent = 'Every pack, every scent, all in stock and ready to ship from the Midwest.';
  if(subs[1]) subs[1].textContent = 'A 4-pack is the cheapest way to find your scent. Most guys find two.';
  const hc = document.querySelector('.hdr-cta'); if(hc) hc.textContent = 'Shop 4-Packs';
  const mc = document.querySelector('.m-cta'); if(mc) mc.textContent = 'Shop 4-Packs';
  const ml = document.querySelector('#mNav a[href="#packs"]'); if(ml) ml.textContent = 'SHOP 4-PACKS';
  document.querySelectorAll('.ctanote').forEach(n=>{ if(/LDW30/.test(n.textContent)) n.innerHTML = '<b>✓</b> 30-Day Risk-Free Returns On Every Order'; });
  const ft = document.querySelector('footer'); if(ft) ft.innerHTML = ft.innerHTML.replace(/Sale prices[^<]+/, '');
  const h2 = document.querySelector('#packs .sec-h'); if(h2) h2.innerHTML = 'Pick Your Pack.';
}
function tick(){
  let ms = SALE_END - new Date();
  const cd = document.getElementById('cd');
  if(ms <= 0){ endSale(); return; }
  cd.classList.add('on');
  const d=Math.floor(ms/86400000); ms-=d*86400000;
  const h=Math.floor(ms/3600000); ms-=h*3600000;
  const m=Math.floor(ms/60000); ms-=m*60000;
  const s=Math.floor(ms/1000);
  document.getElementById('cdD').textContent=d;
  document.getElementById('cdH').textContent=h;
  document.getElementById('cdM').textContent=m;
  document.getElementById('cdS').textContent=s;
}
tick(); setInterval(tick, 1000);

// header nav (homepage)
document.querySelectorAll('.nav-item[data-parent]').forEach(item=>{
  const link = item.querySelector('.nav-link');
  link.setAttribute('aria-expanded','false');
  link.addEventListener('click', e=>{
    const isCoarse = window.matchMedia('(pointer: coarse)').matches;
    if(isCoarse && !item.classList.contains('open')){
      e.preventDefault();
      document.querySelectorAll('.nav-item.open').forEach(o=>{ o.classList.remove('open'); o.querySelector('.nav-link').setAttribute('aria-expanded','false'); });
      item.classList.add('open');
      link.setAttribute('aria-expanded','true');
    }
  });
});
document.addEventListener('click', e=>{
  if(!e.target.closest('.nav-item[data-parent]')){
    document.querySelectorAll('.nav-item.open').forEach(o=>{ o.classList.remove('open'); o.querySelector('.nav-link').setAttribute('aria-expanded','false'); });
  }
});
let lastFocus = null;
function openMnav(){
  lastFocus = document.activeElement;
  document.getElementById('mNav').classList.add('show');
  document.getElementById('mOv').classList.add('show');
  document.getElementById('burgerBtn').setAttribute('aria-expanded','true');
  document.body.style.overflow='hidden';
  document.getElementById('mCloseBtn').focus();
  syncSticky();
}
function closeMnav(){
  document.getElementById('mNav').classList.remove('show');
  document.getElementById('mOv').classList.remove('show');
  document.getElementById('burgerBtn').setAttribute('aria-expanded','false');
  document.body.style.overflow='';
  if(lastFocus) lastFocus.focus();
  syncSticky();
}
document.addEventListener('keydown', e=>{
  if(e.key==='Escape' && document.getElementById('mNav').classList.contains('show')) closeMnav();
});
document.getElementById('mNav').addEventListener('keydown', e=>{
  if(e.key!=='Tab') return;
  const f = document.getElementById('mNav').querySelectorAll('a,button');
  const first=f[0], last=f[f.length-1];
  if(e.shiftKey && document.activeElement===first){ e.preventDefault(); last.focus(); }
  else if(!e.shiftKey && document.activeElement===last){ e.preventDefault(); first.focus(); }
});

// sticky mobile bar after hero (matches the <=980 nav breakpoint; re-checks on resize)
function syncSticky(){
  const show = window.innerWidth <= 980 && window.scrollY > 700 &&
    !document.getElementById('mNav').classList.contains('show');
  document.getElementById('stickybar').classList.toggle('show', show);
}
window.addEventListener('scroll', syncSticky);
window.addEventListener('resize', syncSticky);